/*
 * Created on Sat Jul 08 2017
 *
 * Copyright (c) 2017 Sébastien Hecart
 *
 */

import React, { memo, useCallback, useMemo } from 'react'

import i18n from '@batical/i18n'
import { useContextValue } from '@batical/reducer/src'
import { CalculCodeStateKeys } from '@batical/types/src'
import { ButtonGroup, Button } from '@mui/material'

import { CalculText, ViewLine } from './LineStyleComponent'

export type StepperLineProps = {
  title?: string
  min: number
  max: number
  variableName: string
  calculCode: CalculCodeStateKeys
  onChange?: (va: number) => void
  /**
   * if true, the line is the first of a group
   *
   * @type {boolean}
   */
  first?: boolean
  /**
   * if true, the line is the last of a group
   *
   * @type {boolean}
   */
  last?: boolean
}

const StepperLine = ({ variableName, calculCode, first, last, title, onChange }: StepperLineProps) => {
  const text = useMemo(() => {
    let tex = ''
    if (title) {
      tex = i18n.t(title)
    } else {
      tex = i18n.t(`${calculCode}_${variableName}`)
    }

    return tex
  }, [calculCode, title, variableName])

  const [value, update] = useContextValue(variableName, calculCode)

  const onChangeStepper = useCallback(
    (val: number) => {
      if (onChange) {
        onChange(val)
      } else {
        update(val)
      }
    },
    [onChange, update]
  )

  const handleIncrement = useCallback(() => {
    onChangeStepper(value + 1)
  }, [onChangeStepper, value])

  const handleDecrement = useCallback(() => {
    onChangeStepper(value - 1)
  }, [onChangeStepper, value])

  return (
    <ViewLine first={first} last={last}>
      {/* {image && <ViewLineImage src={image} />} */}
      <CalculText>{text}</CalculText>

      <ButtonGroup size="small" aria-label="small outlined button group">
        <Button onClick={handleDecrement}>-</Button>
        <Button disabled>{value}</Button>
        <Button onClick={handleIncrement}>+</Button>
      </ButtonGroup>
    </ViewLine>
  )
}

export default memo(StepperLine)
